import React, {useEffect} from 'react';
import classes from './Services.module.scss'
import Heading from "../../ui/components/heading/Heading.tsx";
import SubtitleTypeA from "../../ui/components/subtitle-type-a/SubtitleTypeA.tsx";
import pigIcon from '../../media/icons/piggy-bank.svg'
import brushIcon from '../../media/icons/paint-brush.svg'
import clockIcon from '../../media/icons/clock.svg'
import {ListTypeABlock} from "../../ui/components/list-type-a/block/ListTypeABlock.tsx";
import FaqOneColumn from "../../components/frequently-asked-questions/FaqOneColumn.tsx";
import FormCard from "../../components/formCard/FormCard.tsx";
import { useTranslation } from 'react-i18next';


const Services = () => {
    const { t } = useTranslation();
    
    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);
    
    const listABlocks = [
        {"iconSvg": pigIcon, "text": t('services.listABlocks.0.text')},
        {"iconSvg": brushIcon, "text": t('services.listABlocks.1.text')},
        {"iconSvg": clockIcon, "text": t('services.listABlocks.2.text')}
    ]
    
    const listTypeCBlocks= t('services.whyChooseUsBlocks', {returnObjects: true})
    
    const faqQuestions = t('services.Faq', {returnObjects: true})

    return (
        <main>
            <Heading
                startRowText={t('services.title')}
                endRowText={t('services.bluetitle')}
                message={t('services.message')}
                buttonText={t('services.buttonText')}
            />
            <section className="section--white" id="nav-dark">
            <SubtitleTypeA title={t('services.innovativeSolutions')} text={t('services.innovativeSolutionsText')}/>
            <div className={classes['services-container']}>
                <h1>{t('services.listABlocksTitle')}</h1>
                <div className={classes['blocks-container']}>
                    {listABlocks.map(block => <ListTypeABlock key={block.text} block={block}/>)}
                </div>
            </div>
            </section>


            <section className={`${classes['why-choose-us']} section--dark-gray`} id='nav-light'>
                <h1>{t('services.whyChooseUs')}</h1>
                <div className={classes['blocks-container']}>
                    {listTypeCBlocks.map(block => <div key={block.title} className={classes['block--c']}>
                        <div className={classes['text-block']}>
                            <h4>{block.title}</h4>
                            <p>{block.text}</p>
                        </div>
                    </div>)}
                </div>
            </section>

            <section className={`${classes['why-choose-us']} section--light-gray`} id='nav-dark'>
                <FaqOneColumn questions={faqQuestions}/>
            </section>

            <section className="section--white" id="nav-dark">
                <FormCard/>
            </section>
        </main>
);
};

export default Services;